import React from 'react'
import { useHistory } from 'react-router-dom';
import styled from 'styled-components'
import logo from '../../assets/logo.png'

const LogoContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 0%;
`
const Logo = styled.img`
    cursor: pointer;
    @media (max-width: 768px) {
        width: 160px;
    }
`

function LogoArea() {
    let history = useHistory()
    const goToHome = () => {
        history.push("/")
    }
    return (
        <LogoContainer onClick={goToHome}>
            <Logo src={logo} alt="logo" />
        </LogoContainer>
    )
}

export default LogoArea
